let cachedAvailability;

export const isLocalStorageAvailable = () => {
    if (typeof cachedAvailability === 'boolean') {
        return cachedAvailability;
    }

    if (typeof window === 'undefined') {
        cachedAvailability = false;
        return cachedAvailability;
    }

    try {
        const { localStorage } = window;
        if (!localStorage) {
            cachedAvailability = false;
            return cachedAvailability;
        }

        const testKey = '__storage_test__';
        localStorage.setItem(testKey, testKey);
        localStorage.removeItem(testKey);
        cachedAvailability = true;
        return cachedAvailability;
    } catch (error) {
        cachedAvailability = false;
        return cachedAvailability;
    }
};

export default isLocalStorageAvailable;
